// Exported methods to connect the BIMSearch UI to the engine and viewer

import { BimSearch } from "./BimSearch";
import { BimsearchViewer } from "./BimsearchViewer";


// Method to be called when the model first open
// paramters:
// itemStruct - model item (vertion or item) - struct recieved from getNextLevel
// returnMethod - method called when the model is done loading will pass 2 paramters, DataForMenus object, and header for the left menu
// no longer used, doubleClickMethod - method that will be called whenever a user double click of element and should change the left menu selection, pass DataForMenus as parameter
// divElement - ui div element for autodesk viewer
// leafText - opened element name recieved from getNextLevel, only used for adding version to header
export async function loadModel(
    itemStruct,
    returnMethod,
    divElement,
    leafText = null
) {
    //await fetch("/api/forge/datamanagement/projectId?user=" + itemStruct.id)
    var projectIdString;
    if (itemStruct.idForCollections != null){
        projectIdString = itemStruct.idForCollections;
    }
    else {
        projectIdString = itemStruct.id;
    }

    bimSearch = new BimSearch(projectIdString);

    bimSeachViewer = new BimsearchViewer(
        itemStruct,
        divElement,
        bimSearch,
        returnMethod,
        leafText
    );
}

// Register the method that gets called when selection changed
// onSelectionChangeCallback - method called whenever the selection is changed, should effect the quick count widget, pass array of QuickDataField as paramter
export async function registerSelectionChangeMethod(callback) {
    bimSeachViewer.onSelectionChangeCallback = callback;
}

// Unregister the method that gets called when selection changed
export async function unRegisterSelectionChangeMethod() {
    bimSeachViewer.onSelectionChangeCallback = null;
}

// Should be called whenever the viewer div element changes size
export function resizeViewer() {
    if (bimSeachViewer && bimSeachViewer.viewer) bimSeachViewer.viewer.resize();
}

// return a dictonary object
// category name --> [] of QuickDataField
export function getDetailedSelectionInfo() {
    return bimSeachViewer.getFullSelectionData();
}

// Get current view screenshot
export async function viewerGetScreenShot(width, height, callback) {
    if (bimSeachViewer.viewer) {
        bimSeachViewer.viewer.getScreenShot(width, height, callback);
    }
}

export async function getSelection() {
  var selection = bimSeachViewer.viewer.getSelection();
  return selection;
}

// Run the model checker test for inputted discipline and stage
// assumes loadModel is finished - returnMethod has been called
// returns: TestResult
export async function runTest(discipline, stage) {
    return await bimSearch.runTest(discipline, stage);
}

// mark elements in the model according to table selection
// always recieves the entire selection, not the change
// elemets - will be all elements in lines that has atleast 1 check in them
// badElements - all checked missing elements
export async function markModel(elements, badElements) {
    bimSeachViewer.markModel(Array.from(elements), Array.from(badElements));
}

// local instances
var bimSeachViewer; // autodesk viewer
var bimSearch; // Bim search filtered data iterator
